module.exports = __webpack_public_path__ + "static/media/ibm.59ede10e.png";